<template>
    <div>
        <b-row>
            <b-col cols="12" md="4">
                <b-form-group label="Codice Fiscale Operatore">
                    <b-form-input v-model="jsonData.codiceFiscaleOperatore" :disabled="!isNuovo" />
                </b-form-group>
            </b-col>
            <b-col cols="12" md="4">
                <b-form-group label="Nome">
                    <b-form-input v-model="jsonData.nome" />
                </b-form-group>
            </b-col>
            <b-col cols="12" md="4">
                <b-form-group label="Cognome">
                    <b-form-input v-model="jsonData.cognome" />
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="12" md="4">
                <b-form-group label="Telefono">
                    <b-form-input v-model="jsonData.telefono" />
                </b-form-group>
            </b-col>
            <b-col cols="12" md="4">
                <b-form-group label="Email">
                    <b-form-input v-model="jsonData.email" type="email" />
                </b-form-group>
            </b-col>
            <b-col cols="12" md="4">
                <b-form-group label="Sesso">
                    <b-form-select v-model="jsonData.gender" :options="opzioniGender" />
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="12" md="4">
                <b-form-group label="Data di Nascita">
                    <date-picker format="DD/MM/YYYY" value-type="date" type="date" v-model="birthDateModel" :disabled="!isNuovo"></date-picker>
                    <small v-if="!isNuovo" class="text-muted">Non modificabile dopo il censimento</small>
                </b-form-group>
            </b-col>
            <b-col cols="12" md="4">
                <b-form-group label="Tipo Operatore">
                    <b-form-select v-model="tipoOperatoreSelezionato" :options="opzioniTipoOperatore" @change="onCambiaTipoOperatore" />
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col v-if="isNuovo" cols="12" md="6">
                <b-form-group label="Data Inizio (opzionale)">
                    <date-picker format="DD/MM/YYYY" value-type="date" type="date" v-model="dataInizioModel"></date-picker>
                    <small class="text-muted">Se omessa, AnDIamo imposta automaticamente la data odierna</small>
                </b-form-group>
            </b-col>
        </b-row>

        <hr class="sa-hr" />
        <b-button variant="success btn-toolbar float-sm-right" @click="onClickSalva">
            <b-icon icon="check2"></b-icon>
            {{ isNuovo ? "Censisci Utente" : "Salva Modifiche" }}
        </b-button>
    </div>
</template>

<script>
import AndiamoMixin from "../mixins/AndiamoMixin";
import DatePicker from "vue2-datepicker";
import moment from "moment";

export default {
    components: { DatePicker },
    mixins: [AndiamoMixin],
    data() {
        return {
            isNuovo: true,
            birthDateModel: null,
            dataInizioModel: null,
            tipoOperatoreSelezionato: null,
            opzioniGender: [
                { value: null, text: "..." },
                { value: "male", text: "Maschio" },
                { value: "female", text: "Femmina" },
            ],
            // CONFERMATO dal CodeSystem reale tipoOperatore fornito da AnDIamo.
            opzioniTipoOperatore: [
                { value: "1", text: "1 - MMG" },
                { value: "2", text: "2 - PLS" },
                { value: "3", text: "3 - Infermiere" },
                { value: "4", text: "4 - Medico specialista" },
                { value: "5", text: "5 - Medico esperto in cure palliative" },
                { value: "6", text: "6 - Continuità assistenziale" },
                { value: "7", text: "7 - Psicologo" },
                { value: "8", text: "8 - Fisioterapista" },
                { value: "9", text: "9 - Logopedista" },
                { value: "10", text: "10 - OSS" },
                { value: "11", text: "11 - Dietista" },
                { value: "12", text: "12 - Assistente sociale del SSN" },
                { value: "13", text: "13 - Terapista occupazionale" },
                { value: "99", text: "99 - Altro" },
            ],
            jsonData: {
                codiceFiscaleOperatore: "",
                nome: "",
                cognome: "",
                telefono: "",
                email: "",
                gender: null,
                tipoOperatoreCode: "",
                tipoOperatoreDisplay: "",
            },
        };
    },
    mounted() {
        let cf = this.$route.params.codiceFiscaleOperatore;
        this.isNuovo = !cf;
        if (!this.isNuovo) {
            this.jsonData.codiceFiscaleOperatore = cf;
            this.loadData();
        }
    },
    methods: {
        loadData() {
            this.andiamoCaricaDettaglioUtenteLocale(this.jsonData.codiceFiscaleOperatore, this.onLoadSuccess);
        },
        onLoadSuccess(response) {
            this.closeShowModalLoading();
            let lista = response.data.data.list || [];
            if (lista.length) {
                let u = lista[0];
                this.jsonData = { ...this.jsonData, ...u };
                if (u.birthDate) {
                    this.birthDateModel = new Date(u.birthDate);
                }
                if (u.tipoOperatoreCode) {
                    this.tipoOperatoreSelezionato = u.tipoOperatoreCode;
                }
            }
        },
        onCambiaTipoOperatore(value) {
            let opzione = this.opzioniTipoOperatore.find((o) => o.value === value);
            this.jsonData.tipoOperatoreCode = value;
            this.jsonData.tipoOperatoreDisplay = opzione ? opzione.text.split(" - ")[1] : "";
        },
        onClickSalva() {
            if (!this.jsonData.codiceFiscaleOperatore || !this.jsonData.nome || !this.jsonData.cognome) {
                this.$bvToast.toast("Codice Fiscale, Nome e Cognome sono obbligatori", { title: "Attenzione", variant: "warning", solid: true });
                return;
            }
            let body = { ...this.jsonData };
            if (this.isNuovo && this.birthDateModel) {
                body.birthDate = moment(this.birthDateModel).format("YYYY-MM-DD");
            } else {
                delete body.birthDate;
            }
            if (this.isNuovo && this.dataInizioModel) {
                body.dataInizio = moment(this.dataInizioModel).format("YYYY-MM-DD");
            }

            if (this.isNuovo) {
                this.andiamoInserisciUtente(body, this.onSalvaSuccess);
            } else {
                this.andiamoModificaUtente(this.jsonData.codiceFiscaleOperatore, body, this.onSalvaSuccess);
            }
        },
        onSalvaSuccess(response) {
            this.andiamoUtenteSuccess(response);
            this.$router.push("/andiamo/utenti");
        },
    },
};
</script>

<style scoped></style>
